import type { ScheduleEntry } from "./scheduleTypes";

export function compareScheduleEntries(
  left: ScheduleEntry,
  right: ScheduleEntry,
): number {
  return `${left.scheduledDate}|${left.timeSlot ?? ""}|${left.id}`.localeCompare(
    `${right.scheduledDate}|${right.timeSlot ?? ""}|${right.id}`,
  );
}

export function scheduleResultLabel(entry: ScheduleEntry): string | null {
  if (!entry.result) return null;
  const { ourScore, oppScore, forfeitWinner } = entry.result;
  const result = ourScore > oppScore ? "W" : ourScore < oppScore ? "L" : "T";
  return `${result} ${ourScore}\u2013${oppScore}${forfeitWinner ? " · Forfeit" : ""}`;
}

export function scheduleResultBadgeVariant(
  entry: ScheduleEntry,
): "neutral" | "success" | "danger" {
  if (!entry.result) return "neutral";
  if (
    entry.result.forfeitWinner === "us" ||
    entry.result.ourScore > entry.result.oppScore
  ) {
    return "success";
  }
  if (
    entry.result.forfeitWinner === "them" ||
    entry.result.ourScore < entry.result.oppScore
  ) {
    return "danger";
  }
  return "neutral";
}
